import React, { useRef } from 'react';
import './index.css';

import ScrollDownBtn from "../../components/ScrollDownBtn";
import { fullpageApi } from "@fullpage/react-fullpage";
import AddressSearch from "../../components/AddressSearch";
import type { IRoofAddress } from "../../react-app-env";
import CustomRoof from "../../components/CustomRoof";
import { Map } from "../../components/Map";

interface P {
	sectionId?: string
	roofIndex?: number
	activePageId: string
	i18nMap: any
	fullpageApi: fullpageApi
	errors: Map<string, string>
	selectedDraft: IRoofAddress
	roofDrafts: IRoofAddress[]
	typeaheadRef: any
	updateDraft: any
	toggleCustomMode: any
	handleSearchAddress: any
	onClearRoofSelection: any
	onUpdateRoofAddress: any
	onSelectAllBuildingRoofs: any
	isDraftValid: any
	handleCurrentInputChange: any
	handleChangingTabs: any
	isChangingTabs: boolean
	disableFields: boolean
	addressChanged: boolean
	onRemoveRoof?: () => void
}

export default (
	{
		sectionId = 'step1',
		roofIndex = 0,
		activePageId,
		i18nMap,
		fullpageApi,
		errors,
		selectedDraft,
		roofDrafts,
		typeaheadRef,
		updateDraft,
		toggleCustomMode,
		handleSearchAddress,
		onClearRoofSelection,
		onUpdateRoofAddress,
		onSelectAllBuildingRoofs,
		isDraftValid,
		handleCurrentInputChange,
		handleChangingTabs,
		isChangingTabs,
		disableFields,
		addressChanged,
		onRemoveRoof,
	}: P
) => {

	const isActive: boolean = activePageId === sectionId;

	const mapRef = useRef<{ geoLocation: () => void; }>(null);

	// Show welcome message only for first roof when there's a single roof
	const showWelcome = roofIndex === 0 && roofDrafts.length === 1;
	const roofLabel = roofDrafts.length > 1 ? ` - ${i18nMap.roof} ${roofIndex + 1}` : '';

	return (
		<div id={sectionId} className={`header header-roof section`}>

			<h1 className={`h1-content`}>
				{showWelcome && (
					<span className="main-heading-group">
						<span className="h1-line h1-line--left">Ihre persönliche</span>
						<span className="h1-line h1-line--center">Solar-Offerte</span>
						<span className="h1-line h1-line--right">in 3 Minuten</span>
					</span>
				)}
			</h1>

			<div className={`outer-step`}>
				<div className={`sub-step-title`}>
					<div className="sub-step-title-left">
						<span className="roof-icon-label"><i className="fa fa-home" />{roofDrafts.length > 1 && <span className="roof-icon-number">{roofIndex + 1}</span>}</span> {i18nMap.address}
					</div>
					{roofDrafts.length > 1 && onRemoveRoof && !disableFields && (
						<button className="remove-roof-btn" onClick={onRemoveRoof} title={i18nMap.deleteTab}>
							<span className="remove-roof-label">{i18nMap.removeRoof}</span>
							<span className="remove-icon-text">×</span>
						</button>
					)}
				</div>
				<div className={`inner-step step-1`}>

					<div className={`sub-step`}>



						<div className={`sub-step-left`}>

							<div className="header-transition-container">
								<div className={`mode-fade-wrapper ${selectedDraft.hasCustomRoof ? 'hidden' : 'visible'}`}>
									<AddressSearch
										defaultSearchValue={selectedDraft.searchAddress}
										onSelect={handleSearchAddress}
										typeaheadRef={typeaheadRef}
										mapRef={mapRef}
										tabIndex={isActive && !selectedDraft.hasCustomRoof ? 0 : -1}
										i18nMap={i18nMap}
										fullpageApi={fullpageApi}
										clearOnSearch={false}
										hasError={!!errors.get(`${selectedDraft.id}:left`) && !isDraftValid(selectedDraft)}
										handleCurrentInputChange={handleCurrentInputChange}
										selectedDraft={selectedDraft}
										disableFields={disableFields}
										addressChanged={addressChanged}
									/>
								</div>
								<div className={`mode-fade-wrapper ${selectedDraft.hasCustomRoof ? 'visible' : 'hidden'}`}>
									<div className="manual-entry-heading">
										{i18nMap.mapMode}
									</div>
								</div>
							</div>

							<div className="mode-switch-container">
								<div className="mode-switch-label">
									{selectedDraft.hasCustomRoof ? i18nMap.customRoof : i18nMap.mapMode}
								</div>

								<div
									className={`mode-switch ${disableFields && 'disabled'} ${selectedDraft.hasCustomRoof ? 'on' : 'off'} non-selectable`}
									onClick={() => toggleCustomMode(!selectedDraft.hasCustomRoof)}>
								</div>
							</div>

						</div>

						<div className={`map-holder`}>
							{disableFields && <div className={`block-screen`}>

							</div>}

							<div className={`mode-fade-wrapper ${selectedDraft.hasCustomRoof ? 'hidden' : 'visible'}`}>
								<Map {...{
									roofDrafts,
									i18nMap,
									selectedDraft,
									onUpdateRoofAddress,
									onSelectAllBuildingRoofs,
									onClearRoofSelection,
									handleChangingTabs,
									isChangingTabs,
								}} ref={mapRef} />
							</div>

							<div className={`mode-fade-wrapper ${selectedDraft.hasCustomRoof ? 'visible' : 'hidden'}`}>
								<CustomRoof tabIndex={isActive && selectedDraft.hasCustomRoof ? 0 : -1} {...{ i18nMap, selectedDraft, updateDraft, }} />
							</div>
						</div>
					</div>

				</div>
				<ScrollDownBtn onClick={() => fullpageApi.moveSectionDown()} label={i18nMap.nextToRoofType} />
			</div>


		</div>
	);
};
